require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./keyword-i-18-n.json") })
        }
      }, "path---keyword-i-18-n");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---keyword-i-18-n!./.cache/json/keyword-i-18-n.json
// module id = 712
// module chunks = 231608221292675